import Store from '../core/Store';
import { ISettings } from './types';

class SettingsStore extends Store<ISettings> {}

export default SettingsStore;
